import { Component, OnDestroy } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
@Component({
  selector: 'app-popover-self-exclude',
  templateUrl: './popover-self-exclude.component.html',
  styleUrls: ['./popover-self-exclude.component.scss']
})

export class PopoverSelfExcludeComponent implements OnDestroy {

  public responsibleGamingNumber: string;
  responsibleGamingText: string;
  public environmentName: string;
  public councilLink: string;
  public councilLinkText: string;
  public responsibleGamingSMS:string;
  public responsibleGamingSMSCode:string;
  public isMobileApp = false;

  constructor(
    protected config: ConfigService,
    public utils: UtilsService,
    public popOverCtrl: PopoverController,
    private appLinks: AppLinksService,
    private logOutService: LogoutService,
    public navigator: Navigator,
    public platform: Platform
  ){
    this.isMobileApp = this.platform.is('capacitor');
    this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || '';
    this.responsibleGamingText = this.config.getConfig().RESPONSIBLE_GAMING_TEXT || 'If you or someone you know has a gambling problem, crisis counselling and referral services can be accessed by calling';
    this.responsibleGamingSMS = this.config.getConfig().RESPONSIBLE_GAMING_SMS;
    this.responsibleGamingSMSCode = this.config.getConfig().RESPONSIBLE_GAMING_SMS_CODE;

    this.councilLink =  this.config.getConfig().FEATURE_PROBLEM_GAMBLING_LINK;
    this.councilLinkText =  this.config.getConfig().FEATURE_PROBLEM_GAMBLING_LINK_TEXT; //National Council on Problem Gambling
  }

  closePopover() {
    this.popOverCtrl.dismiss(true);
  }

  public goToCouncilLink(): any {
    return this.appLinks.openExternalPage(this.councilLink);
  }

  public goToStateSelfExclude(): any{
    const selfExcludeStateLink = this.config.getConfig().FEATURE_BOARD_EXCLUSION_SITE_URL;
    return this.appLinks.openExternalPage(selfExcludeStateLink);
  }

  ngOnDestroy() {
    this.logOutService.callLogout({ code: 'INVALID_SESSION_TOKEN', reason: 'PLAYER_COOLOFF' });
  }

}
